import { InjectionToken } from '@angular/core';

export interface IConfig {
    useJson: boolean;
    stage: string;
    json: { posts: string; menu: string; page: string; search: string };
    assetsPath: string;
    menuRoot: string;
}

export const APP_CONFIG = new InjectionToken<IConfig>('APP_CONFIG');
